import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import HSK from '../views/HSK.vue'
import HSK2026 from '../views/HSK2026.vue'
import Prices from '../views/Prices.vue'
import Teachers from '../views/Teachers.vue'
import Contacts from '../views/Contacts.vue'
import TeacherProfile from '../views/TeacherProfile.vue'
import Reviews from '../views/Reviews.vue'
import HSKCourses from '../views/HSKCourses.vue'
import CourseDetail from '../views/CourseDetail.vue'
import CategoryCourses from '../views/CategoryCourses.vue'
import Privacy from '../views/Privacy.vue'
import Terms from '../views/Terms.vue'

const routes = [
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: {
      title: 'Политика конфиденциальности - Мама я в Китае',
      description: 'Политика конфиденциальности сайта «Мама, я в Китае». Правила обработки персональных данных в соответствии с 152-ФЗ.'
    }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: Terms,
    meta: {
      title: 'Пользовательское соглашение - Мама я в Китае',
      description: 'Пользовательское соглашение сайта «Мама, я в Китае». Условия использования сайта, правила регистрации и использования cookie.'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Мама я в Китае - Изучение китайского языка онлайн',
      description: 'Изучение китайского языка онлайн. Группы до 2-3 человек, удобное расписание, пробный урок бесплатно.'
    }
  },
  {
    path: '/hsk',
    name: 'HSK',
    component: HSK,
    meta: {
      title: 'Подготовка к HSK - Мама я в Китае',
      description: 'Подготовка к экзамену HSK всех уровней. Профессиональные преподаватели, эффективная программа обучения.'
    }
  },
  {
    path: '/hsk-2026',
    name: 'HSK2026',
    component: HSK2026,
    meta: {
      title: 'Подготовка к HSK по старому формату в 2026 году — Мама я в Китае',
      description: 'Подготовьтесь к HSK по старому формату в 2026 году: курс HSK 4 в подарок к абонементу с преподавателем или HSK 4 и HSK 5 со скидкой 20%.'
    }
  },
  {
    path: '/prices',
    name: 'Prices',
    component: Prices,
    meta: {
      title: 'Цены на курсы китайского языка - Мама я в Китае',
      description: 'Актуальные цены на курсы китайского языка. Индивидуальные и групповые занятия. Гибкая система оплаты.'
    }
  },
  {
    path: '/teachers',
    name: 'Teachers',
    component: Teachers,
    meta: {
      title: 'Наши преподаватели - Мама я в Китае',
      description: 'Опытные преподаватели китайского языка с высшим образованием и опытом работы. Носители языка и русскоязычные преподаватели.'
    }
  },
  {
    path: '/teacher/:id',
    name: 'TeacherProfile',
    component: TeacherProfile,
    meta: {
      title: 'Преподаватель - Мама я в Китае',
      description: 'Профиль преподавателя китайского языка'
    }
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: Reviews,
    meta: {
      title: 'Отзывы учеников - Мама я в Китае',
      description: 'Отзывы наших учеников о курсах китайского языка. Реальные истории успеха и достижений.'
    }
  },
  {
    path: '/courses-hsk',
    name: 'HSKCourses',
    component: HSKCourses,
    meta: {
      title: 'Курсы HSK - Мама я в Китае',
      description: 'Курсы подготовки к экзамену HSK всех уровней. Структурированная программа, практические задания.'
    }
  },
  {
    path: '/product/:slug',
    name: 'ProductDetail',
    component: CourseDetail,
    meta: {
      title: 'Курс - Мама я в Китае',
      description: 'Детальная информация о курсе китайского языка'
    }
  },
  {
    path: '/category/:slug',
    name: 'CategoryCourses',
    component: CategoryCourses,
    meta: {
      title: 'Курсы - Мама я в Китае',
      description: 'Курсы китайского языка по категориям'
    }
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
    meta: {
      title: 'Контакты - Мама я в Китае',
      description: 'Свяжитесь с нами для записи на пробный урок или получения консультации по курсам китайского языка.'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Если есть сохраненная позиция (например, при нажатии назад)
    if (savedPosition) {
      return savedPosition
    }
    // Если есть якорь в URL
    if (to.hash) {
      // Используем Promise для задержки, чтобы элемент успел отрендериться
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.querySelector(to.hash)
          if (element) {
            resolve({
              el: to.hash,
              behavior: 'smooth',
              top: 80 // Учитываем высоту фиксированного хедера
            })
          } else {
            // Если элемент не найден, прокручиваем вверх
            resolve({ top: 0, behavior: 'smooth' })
          }
        }, 100)
      })
    }
    // По умолчанию прокручиваем вверх
    return { top: 0, behavior: 'smooth' }
  }
})

// Инициализация счетчика фиксирует первый просмотр. Для последующих переходов
// внутри SPA отправляем отдельный просмотр без перезагрузки страницы.
router.afterEach((to, from) => {
  if (from.name && typeof window.ym === 'function') {
    window.ym(87005371, 'hit', window.location.href, {
      referer: window.location.origin + from.fullPath,
      title: document.title
    })
  }
})

// Обновление заголовка страницы и метаданных
router.beforeEach((to, from, next) => {
  // Устанавливаем заголовок страницы
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // Обновляем мета-тег description
  let metaDescription = document.querySelector('meta[name="description"]')
  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.setAttribute('name', 'description')
    document.head.appendChild(metaDescription)
  }
  if (to.meta.description) {
    metaDescription.setAttribute('content', to.meta.description)
  }
  
  // Обновляем Open Graph теги
  let ogTitle = document.querySelector('meta[property="og:title"]')
  if (!ogTitle) {
    ogTitle = document.createElement('meta')
    ogTitle.setAttribute('property', 'og:title')
    document.head.appendChild(ogTitle)
  }
  if (to.meta.title) {
    ogTitle.setAttribute('content', to.meta.title)
  }
  
  let ogDescription = document.querySelector('meta[property="og:description"]')
  if (!ogDescription) {
    ogDescription = document.createElement('meta')
    ogDescription.setAttribute('property', 'og:description')
    document.head.appendChild(ogDescription)
  }
  if (to.meta.description) {
    ogDescription.setAttribute('content', to.meta.description)
  }
  
  // Обновляем og:image если есть в метаданных
  if (to.meta.image) {
    let ogImage = document.querySelector('meta[property="og:image"]')
    if (!ogImage) {
      ogImage = document.createElement('meta')
      ogImage.setAttribute('property', 'og:image')
      document.head.appendChild(ogImage)
    }
    ogImage.setAttribute('content', to.meta.image)
  }
  
  // Добавляем canonical URL для Яндекс
  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  const baseUrl = window.location.origin
  const canonicalUrl = baseUrl + to.fullPath
  canonical.setAttribute('href', canonicalUrl)
  
  // Обновляем og:url
  let ogUrl = document.querySelector('meta[property="og:url"]')
  if (!ogUrl) {
    ogUrl = document.createElement('meta')
    ogUrl.setAttribute('property', 'og:url')
    document.head.appendChild(ogUrl)
  }
  ogUrl.setAttribute('content', canonicalUrl)
  
  next()
})

export default router
